// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-container {
    height: 32rem;
}

@media (max-width: 1024px) {
    .canvas-container {
        height: 24rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/graphs/stackedBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".canvas-container {\n    height: 32rem;\n}\n\n@media (max-width: 1024px) {\n    .canvas-container {\n        height: 24rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
